<template>
  <div class="package orders delivery">
      
      <div class="box-white-wrapper" v-if="dataRoute != undefined">
          
          <div class="wrap-box order-wrap">
              
              <a href="/routes" class="viewBill">Regresar</a>
      
              <div class="item">
                  <div class="head">
                      <div class="icon">
                          <img src="@/assets/images/package.png" alt="" class="img-fluid">
                      </div>
                      <div class="subTitle">Detalle Ruta</div>
                  </div>
                  <div class="detail">
                      <h3>Fecha Solicitud:</h3>
                      <p>{{ dataRoute.createdAt | moment('DD/MM/YYYY') }}</p>
                  </div>
                  <div class="detail">
                      <h3>Mensjero:</h3>
                      <p class="flex center">
                          {{ dataRoute.assignedToName}} 
                          <vs-icon @click="changeDispatchStatus()" icon="refresh"></vs-icon> 
                      </p>
                  </div>
                  <div class="detail">
                      <h3>Comentarios:</h3>
                      <p>{{ dataRoute.comments}}</p>
                  </div>
                  <!-- <div class="detail changeStatus">
                      <h3>Estado:</h3>
                      <p @click="changeDispatchStatus()">{{ dispatchOrden.statusName}} <vs-icon icon="refresh"></vs-icon></p>
                  </div>  -->
              </div>
          </div>

          <div class="title">Listado de paquetes</div>
          <div class="order-table">
            <vs-table :data="dataPacks" pagination search max-items="50" id="josue">
                <template slot="header">
                    <div class="extra-actions">
                      <vs-button color="primary" type="border" icon="print" @click="exportOrderDetail" class="ml-10">Imprimir</vs-button>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th sort-key="customerName">Nombre</vs-th>
                    <vs-th sort-key="tracking">Tracking</vs-th>
                    <vs-th sort-key="name">Zona </vs-th>
                    <vs-th sort-key="">Forma de pago </vs-th>
                    <vs-th sort-key="">Monto </vs-th>
                    <vs-th sort-key=""> Comentarios </vs-th>
                    <vs-th sort-key="statusName" style="min-width: 120px;">Recibo</vs-th>
                    
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].customerName">{{data[indextr].customerName}}
                          <br>
                          <p>
                            <strong>Tel: {{data[indextr].phone}}</strong> 
                          </p>
                        </vs-td>
                        <vs-td :data="data[indextr].tracking">
                          <p v-if="data[indextr].mia != null" v-html="data[indextr].mia"></p> 
                          <br>
                          <p v-html="data[indextr].tracking"></p> 
                        </vs-td>
                        <vs-td :data="data[indextr].zone">{{data[indextr].zone}}</vs-td>  
                        <vs-td :data="data[indextr].paymentWay">{{data[indextr].paymentWay}}</vs-td>  
                        <vs-td :data="data[indextr].amountDol">{{data[indextr].amountDol}}</vs-td>  
                        <vs-td :data="data[indextr].comments">{{data[indextr].comments}}</vs-td>  
                        <vs-td :data="data[indextr].customerName">
                        </vs-td>  
                    </vs-tr>
                </template>
            </vs-table>
          </div>
      </div>
      
      <modalDispatch @modal-event="handleActionModalPackage" :packID="dataRoute.id"  
        :selected="currentMensajero" :show="modalActive"></modalDispatch>

  </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import InventoryService from "@/services/InventoryService"
import DeliveryService from "@/services/DeliveryService"
import ModalDispatch from '@/components/Modal/Distribuitors'
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
export default {
name: 'RouteDeliveryDetail',
mixins: [helper],
components: { ModalDispatch },
data () {
  return {
      dataRoute: {},
      dataPacks: [],
      dispatchOrden: {},
      typeChangeSt: false,
      packageId: "",
      currentMensajero: {},
      modalActive: false,
      dispatchId: "",
      sendEmail: "",
      sendCC: '',
      buttonsHidden: false,
      activeSendReport: false,
  }
},
created(){
  this.Roles = Role
},
computed: {
  ...mapState(['userInfoData']),
},
beforeMount() {
  this.$Progress.start();
},
mounted (){
  this.getRouteDetail(this.$route.params.id);
},
methods: {
  exportOrderDetail() {
    let doc = new jsPDF('l')
    doc.setFont("helvetica");
    doc.setFontSize(13);

    var img = new Image()
    img.src = require('@/assets/images/logo.png');
    const pageWidth = doc.internal.pageSize.width; // pdf page width
    doc.addImage(img, 'png', pageWidth -50, 10, 35, 15)
    doc.setFont(undefined, "", "bold");
    doc.text("DELV #:", 14, 35);
    doc.setFont(undefined, "", "normal");
    doc.text(this.dataRoute.comments , 35, 35);
  
    
    doc.text("Mensajero:", 14, 45);
    doc.setFont(undefined, "", "normal");
    doc.text(this.dataRoute.assignedToName, 40, 45);

    doc.text("Packages", 14, 60);
    doc.line(14, 65, pageWidth-14, 65);

    autoTable(doc, { 
      // margin: { top: 115 },
      startY: 70,
      theme: "grid",
      styles: {
        fontSize: 10,
      },
      headStyles :{ 
        fillColor : [32, 69, 112],
      },
      columnStyles: { 
        1: { halign: 'left', minCellWidth: 50 },
        2: { halign: 'left' }, 
        3: { halign: 'left', minCellWidth: 30 },
        4: { halign: 'left', minCellWidth: 20}, 
        5: { halign: 'left' }, 
        6: { halign: 'left', minCellWidth: 25  }, 
      }, 
      html: '.vs-table' }
    )
    // doc.save('table.pdf')
    doc.autoPrint();
    // doc.output('dataurlnewwindow');
    doc.save('Ruta-'+this.dataRoute.comments+'.pdf')

  },
  closedModaSendReport(){
    this.activeSendReport = false
    this.buttonsHidden = false
    this.sendEmail = ''
    this.sendCC = ""
  },
  confirmToSent(){
      const that = this
      that.buttonsHidden = true
      InventoryService.sendReportByEmail({
        id: this.dispatchId,
        emailreport: this.sendEmail,
        cc: this.sendCC
      })
      .then(() => {
          that.activeSendReport = false
          that.buttonsHidden = false
          that.sendEmail = ''
          that.sendCC = ""
          that.$vs.loading.close('#btnDownloadPacks .con-vs-loading')
          that.updateMultiplePacks = []
    //      that.retrievePackages()
          that.$vs.notify({title:'Información!',text:'El documento fue enviado exitosamente!',color:'success',icon:'check'})
          
      })
      .catch(e => {
          console.log(e)
          that.buttonsHidden = false
          that.$vs.notify({title:'Información!',text:'Error enviado el documento!',color:'danger',icon:'error_outline'})                
      });
  },
  
  
  getRouteDetail(id) {
      DeliveryService.getRoute(id)
      .then(response => {
          this.dataRoute = response.data.route
          this.dataPacks = response.data.detail
          this.currentMensajero = { id: this.dataRoute.assignedTo, name: this.dataRoute.assignedToName}
          
          const groupedData  = this.groupedByCustomerId(this.dataPacks);
          this.dataPacks = Object.values(groupedData).map(group => {
            return group.reduce((acc, item) => {
              acc.address = item.address,
              acc.canton = item.canton,
              acc.customerId = item.customerId;
              acc.district = item.district;
              acc.invoice  = item.invoice;
              acc.location = item.location;
              acc.mia = item.mia != null ? (acc.mia ? `${acc.mia} <br> ${item.mia}` : item.mia) : acc.mia;
              acc.name  = item.name;
              acc.phone  = item.phone;
              acc.pkgId = item.pkgId;
              acc.province = item.province;
              acc.regDate  = item.regDate;
  
              // Verifica que el tracking no esté duplicado antes de agregarlo
              acc.tracking = acc.tracking ? acc.tracking : [];
              if (!acc.tracking.includes(item.tracking)) {
                // acc.tracking.push(item.tracking);
                acc.tracking = acc.tracking ? `${acc.tracking} <br> ${item.tracking}` : item.tracking;
              }
              
              // acc.tracking = acc.tracking ? `${acc.tracking} <br> ${item.tracking}` : item.tracking;
              acc.zone = item.zone;
              acc.comments = item.comments;
              acc.amountDol = !isNaN(item.amountDol) ? item.amountDol : '-';
              acc.customerName = item.customerName;
              acc.paymentWay = item.paymentWay;
              return acc;
            }, { tracking: [], mia: '' });
          });
      })
      .catch( () => {
          this.$vs.notify({title:'Error!',text:'Error obteniendo el detalle de la ruta',color:'danger',icon:'error_outline'})
      });
      this.$Progress.finish()
  },

  handleActionModalPackage(response){
    if(response.error !=  undefined){
      if(!response.error){
          this.dataRoute.assignedTo = response.response.id;
          this.dataRoute.assignedToName = response.response.name;
        this.$vs.notify({title:'Información!',text:'El mensjero fue asignado exitosamente!',color:'success',icon:'check'})
      }else{
          this.$vs.notify({title:'Información!',text:'Error asignando el mensajero',color:'danger',icon:'error_outline'})
      }
    }
    this.modalActive = response.active      
  },

  changeDispatchStatus(){
      this.modalActive = true
  },
  
  groupedByCustomerId (data,) { 
    return data.reduce((acc, item) => {
      const { cu01Id } = item;
      if (!acc[cu01Id]) {
        acc[cu01Id] = [];
      }
      acc[cu01Id].push(item);
      return acc;
    }, {});
  },

}
}
</script>
